// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 739 ? "8412908f" : chunkId) + "." + {"621":"c08676fb743bbacf","739":"ac9796e696061cc7"}[chunkId] + ".js";
};